module.exports = __webpack_public_path__ + "media/images/icons/flags/IE-656020694149e32ac69c6554c2d4f219.svg";